import { get, post, put } from "../common/apiClient";

const PATH_TEST = "/exam-result";
const postTest = async (id, body) => {
  return await post(PATH_TEST + `/submit-test/${id}`, body);
};
const getResultById = async (examId) => {
  return await get(PATH_TEST + `/${examId}`);
};
const getResultAll = async (id, examRoomId) => {
  return await get(PATH_TEST + `?examId=${id}&examRoomId=${examRoomId}`);
};
// /exam-result/check-correct-answers/:examId
const getResultHistory = async (id, examRoomId) => {
  return await get(PATH_TEST + `/check-correct-answers/${id}/${examRoomId}`);
};

const getExamResultBySubject = async (examId) => {
  return await get(PATH_TEST + `/subject/${examId}`);
};

const getExamResultsByAssessmentId = async (assessmentId) => {
  return await get(PATH_TEST + `/by-assessmentid/${assessmentId}`);
};

const getExamResultsRanking = async (examId, page = 1, limit = 10) => {
  return await get(
    PATH_TEST + `/ranking/${examId}?page=${page}&limit=${limit}`
  );
};
const updateCompletedDate = async (assessmentId) => {
  return await put(PATH_TEST + `/update-assessment-date/${assessmentId}`);
};
export {
  postTest,
  getResultById,
  getResultAll,
  getResultHistory,
  getExamResultBySubject,
  getExamResultsByAssessmentId,
  getExamResultsRanking,
  updateCompletedDate,
};
